




















import { Component, Prop, Vue } from 'vue-property-decorator';
import _ from 'lodash';

@Component({
    name: 'product-stocks-table',
})
export default class ProductStocksTable extends Vue {
    @Prop(Array) readonly stocks: Array<any>;

    get parsedStocks() {
        let row = 1;
        let stores = this.stocks;
        stores.unshift({
            name: 'Total',
            qty: stores.reduce((prev, loop) => loop.qty + prev, 0),
        });
        let stocks = _.values(
            _.groupBy(
                stores.map((store, index: any) => {
                    if (index % 2 == 0) {
                        row++;
                    }
                    // console.log(index, row);
                    return {
                        row,
                        ...store,
                    };
                }),
                'row'
            )
        );
        // console.log(stocks);
        return stocks;
    }
}
